import axios from 'axios';
import { DataGrid, Menu } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { Column } from 'devextreme-react/cjs/data-grid';
import { Item } from 'devextreme-react/list';
import notify from 'devextreme/ui/notify';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import GlobalParams from '../../helpers/GlobalParams';
import './Enquiries.scss';
import { EnquiriesForm } from './EnquiriesForm';
import { EnquiriesGrid } from './EnquiriesGrid';

var default_form =
{
  isNew: true,
  Subject: null,
  Narration: '',
  Response: '',
};
const Enquiries = () => {
  var filesData = [];


  const [vsEdit, setVsEdit] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [popupEnquiryVisible, setPopupEnquiryVisible] = useState(false);

  const [enquiryStore, setEnquiryStore] = useState();

  const [popEnquiryTitle, setPopEnquiryTitle] = useState('');



  const handleCancelEnquiryButtonClick = () => {
    setPopupEnquiryVisible(false);
  }
  const emptyItemConfig = {
    colSpan: 3,
    itemType: 'empty',
  };













  return (
    /*Have a grid with: id, subject, narration, date, status - enquiries */
    <div>

      <EnquiriesForm open={popupEnquiryVisible} onClose={handleCancelEnquiryButtonClick} title={popEnquiryTitle} vsEdit={false} Subject='' Response='' />
      
      <div>
        <br></br>
        <Button
          type='danger'
          text="Write to Britam"
          icon='message'
          onClick={() => {

            setPopEnquiryTitle('New Enquiry');
            setVsEdit(false);
            setPopupEnquiryVisible(true);
            setEnquiryStore({ ...enquiryStore, isNew: true });

          }}
        />
      </div>
      <br></br>
      <EnquiriesGrid />

    </div>
  );
};

export default Enquiries;